import FooterStoreClass from "./FooterStore";
import HeaderStoreClass from "./HeaderStore";
import NavListStoreClass from "./NavListStore";
import CommonStoreClass from "./CommonStore";
import LoginStoreClass from "./Login";
import SearchBarStoreClass from "./SearchBarStore";
import StoreLocatorStore from "./StoreLocatorStore";
import StoreListStore from "./StoreListStore";
import ProductStoreClass from "./ProductStore";
import MybagStoreClass from "./MybagStore";
import WishListStoreClass from "./WishListStore";
import BrandStoreClass from "./BrandStore";

/**
  Inject Inital State into Stores
*/
const setState = state => {
  // console.log(state, "state");
  const stores = {};
  const MybagStore = state
    ? new MybagStoreClass(state.MybagStore)
    : new MybagStoreClass();
  const WishListStore = state
    ? new WishListStoreClass(state.WishListStore)
    : new WishListStoreClass();
  Object.assign(stores, {
    MybagStore,
    WishListStore,
    FooterStore: state
      ? new FooterStoreClass(state.FooterStore)
      : new FooterStoreClass(),
    HeaderStore: state
      ? new HeaderStoreClass(state.header)
      : new HeaderStoreClass(),
    NavListStore: state
      ? new NavListStoreClass(state.NavListStore)
      : new NavListStoreClass(),
    CommonStore: state
      ? new CommonStoreClass(state.CommonStore)
      : new CommonStoreClass(),
    LoginStore: state
      ? new LoginStoreClass(state.login)
      : new LoginStoreClass(),
    SearchBarStore: state
      ? new SearchBarStoreClass(state.searchBar)
      : new SearchBarStoreClass(),
    StoreLocatorStore: state
      ? new StoreLocatorStore(state.StoreLocatorStore)
      : new StoreLocatorStore(),
    StoreListStore: state
      ? new StoreListStore(state.StoreListStore)
      : new StoreListStore(),
    ProductStore: state
      ? new ProductStoreClass(state.ProductStore)
      : new ProductStoreClass(),
    BrandStore: state
      ? new BrandStoreClass(state.BrandStore)
      : new BrandStoreClass(),
  });
  return stores;
};

class Stores {
  constructor(state = {}) {
    this.setStores = this.setStores.bind(this);
    this.getStores = this.getStores.bind(this);
    this.stores = setState(state);
  }
  getStores() {
    return this.stores;
  }
  setStores(state) {
    this.stores = setState(state);
  }
}
export default Stores;



// WEBPACK FOOTER //
// ./src/stores/Stores.js